// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftbar {
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  transition: width 0.2s ease;
}

/* Logo Section */
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 24px;
  margin-bottom: 32px;
  flex-shrink: 0;
}

/* Navigation Menu */
.nav-menu {
  padding: 0 16px;
  flex-shrink: 0;
}

.nav-menu .ant-menu-item {
  margin: 4px 0 !important;
  border-radius: 8px;
}

.nav-menu .ant-menu-item:hover {
  background-color: #f5f5f5 !important;
  color: var(--primary-color) !important;
}

.nav-menu .ant-menu-item-selected {
  /* background-color: #E6F4FF !important; */
  color: var(--primary-color) !important;
}

/* Divider */
.divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.06);
  margin: 24px 0;
  flex-shrink: 0;
}

/* Workspace Menu */
.workspace-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* .workspace-menu .ant-menu {
  flex: 1;
  overflow: hidden;
} */

.workspace-menu .ant-menu-item {
  margin: 4px 0 !important;
  border-radius: 8px;
  color: rgba(0, 0, 0, 0.45);
}

.workspace-menu .ant-menu-item:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.88) !important;
}

.workspace-menu .ant-menu-submenu-title {
  padding: 8px 16px !important;
  margin: 4px 0 !important;
  border-radius: 8px;
}

.workspace-menu-collapsed .ant-menu-submenu-title {
  padding: 0 0 0 8px !important;
  border-radius: 8px;
}

.workspace-menu .ant-menu-submenu-title:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.88) !important;
}

.workspace-menu .ant-menu-submenu-content {
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}

/* Action Buttons */
.action-btn {
  color: rgba(0, 0, 0, 0.45);
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  color: var(--primary-color) !important;
}

/* New Folder Button */
.new-folder-btn {
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  justify-content: flex-start;
  width: 100%;
}

.new-folder-btn:hover {
  color: rgba(0, 0, 0, 0.88);
  background-color: #f5f5f5;
}

/* Override Ant Design default styles */
/* .leftbar  .ant-menu-item {
  height: 30px !important;
  line-height: 30px !important;
} */
.collapseLeftBar .ant-menu-item {
  width: auto;
}

.ant-menu-item .anticon {
  font-size: 18px;
  margin-right: 12px;
}

.ant-menu-item-selected::after {
  display: none;
}

/* Workspace Menu Submenu */
.workspace-menu .ant-menu-submenu {
  background: transparent !important;
}

.workspace-menu .ant-menu-submenu-content {
  background: transparent !important;
}

.workspace-menu .ant-menu-submenu-title {
  height: 30px !important;
  line-height: 30px !important;
}

.workspace-section {
  display: flex;
  flex-direction: column;
}

.workspace-header {
  flex-shrink: 0;
}

.menu-container {
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(100vh - 136px);
  transition:
    opacity 0.3s ease-out,
    transform 0.3s ease-out;
  opacity: 0;
  transform: translateY(-10px);
  visibility: hidden;
}

.menu-container.visible {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

/* FileExplorer integration styles */
.leftbar .file-explorer {
  margin-top: 8px;
}

.leftbar .file-explorer-root {
  padding: 0;
}

.leftbar .file-context-item {
  border-radius: 6px;
  margin-bottom: 4px;
  padding: 4px 8px;
  transition: all 0.2s ease;
}

.leftbar .file-context-item:hover {
  background-color: #f5f5f5;
}

.leftbar .file-context-item.selected {
  background-color: #e6f4ff;
  color: var(--primary-color);
}

.leftbar .file-explorer .file-text-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.leftbar .file-options-wrapper {
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.leftbar .file-context-item:hover .file-options-wrapper {
  opacity: 1;
}

.leftbar .pop-over-menu {
  opacity: 0;
  transition: opacity 0.2s ease;
}
.leftbar .workspace-item:hover .pop-over-menu {
  opacity: 1;
}

.workspace-submenu-popup {
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}
/* .menu-container.hidden {
  opacity: 0;
  transform: translateY(-10px); 
  visibility: hidden; 
} */

.workspace-menu {
  border: none;
}
.workspace-menu .ant-menu-sub {
  max-height: calc(100vh - 385px) !important;
  overflow-y: auto !important;
}

.folder-toggle-button {
  left: 246px;
}

.workspace-menu .ant-menu-item-selected {
  background-color: transparent !important;
}
.leftbar:hover {
  border-right: 1px solid var(--primary-color, #a064fa) !important;
}
.leftbar-slider:hover {
  border-color: var(--primary-color, #a064fa) !important;
  color: var(--primary-color, #a064fa) !important;
}

.leftbar:hover .leftbar-slider {
  border-color: var(--primary-color, #a064fa) !important;
  color: var(--primary-color, #a064fa) !important;
}
.resize-handle:hover .leftbar-slide {
  border-color: var(--primary-color, #a064fa) !important;
  color: var(--primary-color, #a064fa) !important;
}
.resize-handle:active .leftbar-slide {
  border-color: var(--primary-color, #a064fa) !important;
  color: var(--primary-color, #a064fa) !important;
}
/* Context menu styles */
.ant-popover-inner-content .ant-btn {
  /* width: 100%; */
  text-align: left;
  justify-content: center;
  border: none;
  background: transparent;
  /* padding: 8px 12px; */
  /* margin-bottom: 4px; */
  border-radius: 4px;
}

/* .ant-popover-inner-content .ant-btn:hover {
  background-color: #f5f5f5;
  color: var(--primary-color);
} */

/* Improve leftbar slider button */
.leftbar-slider {
  position: absolute;
  top: 50%;
  right: -16px;
  transform: translateY(-50%);
  z-index: 151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

/* Disable transitions during resize */
body.resizing-leftbar .leftbar {
  transition: none !important;
}

/* .workspace-menu .ant-tooltip-inner {
  background-color: #333 !important; 
  color: #fff !important;            
  font-size: 12px;                  
} */

/* Fix for tooltip text color */
.ant-tooltip-inner {
  color: white !important;
}

/* Fix for menu title in collapsed mode */
.workspace-menu-collapsed .ant-menu-item-only-child {
  padding-left: 8px !important;
}

/* Ensure proper tooltip behavior in collapsed state */
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner {
  color: white !important;
}

.leftbar-workspaceList {
  overflow-y: scroll;
  max-height: calc(100vh - 420px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Leftbar/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;;;GAGG;AACH;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B;;2BAEyB;EACzB,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;;;;GAIG;;AAEH;EACE,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,gEAAgE;AAClE;AACA;EACE,sDAAsD;EACtD,+CAA+C;AACjD;;AAEA;EACE,sDAAsD;EACtD,+CAA+C;AACjD;AACA;EACE,sDAAsD;EACtD,+CAA+C;AACjD;AACA;EACE,sDAAsD;EACtD,+CAA+C;AACjD;AACA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;AAC7B;;AAEA;;;;GAIG;;AAEH,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,4BAA4B;AAC9B;;AAEA,sDAAsD;AACtD;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC","sourcesContent":[".leftbar {\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  padding: 24px 0;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.2s ease;\n}\n\n/* Logo Section */\n.logo-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 24px;\n  margin-bottom: 32px;\n  flex-shrink: 0;\n}\n\n/* Navigation Menu */\n.nav-menu {\n  padding: 0 16px;\n  flex-shrink: 0;\n}\n\n.nav-menu .ant-menu-item {\n  margin: 4px 0 !important;\n  border-radius: 8px;\n}\n\n.nav-menu .ant-menu-item:hover {\n  background-color: #f5f5f5 !important;\n  color: var(--primary-color) !important;\n}\n\n.nav-menu .ant-menu-item-selected {\n  /* background-color: #E6F4FF !important; */\n  color: var(--primary-color) !important;\n}\n\n/* Divider */\n.divider {\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.06);\n  margin: 24px 0;\n  flex-shrink: 0;\n}\n\n/* Workspace Menu */\n.workspace-menu {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* .workspace-menu .ant-menu {\n  flex: 1;\n  overflow: hidden;\n} */\n\n.workspace-menu .ant-menu-item {\n  margin: 4px 0 !important;\n  border-radius: 8px;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.workspace-menu .ant-menu-item:hover {\n  background-color: #f5f5f5 !important;\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.workspace-menu .ant-menu-submenu-title {\n  padding: 8px 16px !important;\n  margin: 4px 0 !important;\n  border-radius: 8px;\n}\n\n.workspace-menu-collapsed .ant-menu-submenu-title {\n  padding: 0 0 0 8px !important;\n  border-radius: 8px;\n}\n\n.workspace-menu .ant-menu-submenu-title:hover {\n  background-color: #f5f5f5 !important;\n  color: rgba(0, 0, 0, 0.88) !important;\n}\n\n.workspace-menu .ant-menu-submenu-content {\n  max-height: calc(100vh - 300px);\n  overflow-y: auto;\n}\n\n/* Action Buttons */\n.action-btn {\n  color: rgba(0, 0, 0, 0.45);\n  border: none !important;\n  background: transparent !important;\n  padding: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-btn:hover {\n  color: var(--primary-color) !important;\n}\n\n/* New Folder Button */\n.new-folder-btn {\n  color: rgba(0, 0, 0, 0.45);\n  text-align: left;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.new-folder-btn:hover {\n  color: rgba(0, 0, 0, 0.88);\n  background-color: #f5f5f5;\n}\n\n/* Override Ant Design default styles */\n/* .leftbar  .ant-menu-item {\n  height: 30px !important;\n  line-height: 30px !important;\n} */\n.collapseLeftBar .ant-menu-item {\n  width: auto;\n}\n\n.ant-menu-item .anticon {\n  font-size: 18px;\n  margin-right: 12px;\n}\n\n.ant-menu-item-selected::after {\n  display: none;\n}\n\n/* Workspace Menu Submenu */\n.workspace-menu .ant-menu-submenu {\n  background: transparent !important;\n}\n\n.workspace-menu .ant-menu-submenu-content {\n  background: transparent !important;\n}\n\n.workspace-menu .ant-menu-submenu-title {\n  height: 30px !important;\n  line-height: 30px !important;\n}\n\n.workspace-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.workspace-header {\n  flex-shrink: 0;\n}\n\n.menu-container {\n  flex-grow: 1;\n  overflow-y: auto;\n  max-height: calc(100vh - 136px);\n  transition:\n    opacity 0.3s ease-out,\n    transform 0.3s ease-out;\n  opacity: 0;\n  transform: translateY(-10px);\n  visibility: hidden;\n}\n\n.menu-container.visible {\n  opacity: 1;\n  transform: translateY(0);\n  visibility: visible;\n}\n\n/* FileExplorer integration styles */\n.leftbar .file-explorer {\n  margin-top: 8px;\n}\n\n.leftbar .file-explorer-root {\n  padding: 0;\n}\n\n.leftbar .file-context-item {\n  border-radius: 6px;\n  margin-bottom: 4px;\n  padding: 4px 8px;\n  transition: all 0.2s ease;\n}\n\n.leftbar .file-context-item:hover {\n  background-color: #f5f5f5;\n}\n\n.leftbar .file-context-item.selected {\n  background-color: #e6f4ff;\n  color: var(--primary-color);\n}\n\n.leftbar .file-explorer .file-text-wrapper {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.leftbar .file-options-wrapper {\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.leftbar .file-context-item:hover .file-options-wrapper {\n  opacity: 1;\n}\n\n.leftbar .pop-over-menu {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n.leftbar .workspace-item:hover .pop-over-menu {\n  opacity: 1;\n}\n\n.workspace-submenu-popup {\n  max-height: calc(100vh - 300px);\n  overflow-y: auto;\n}\n/* .menu-container.hidden {\n  opacity: 0;\n  transform: translateY(-10px); \n  visibility: hidden; \n} */\n\n.workspace-menu {\n  border: none;\n}\n.workspace-menu .ant-menu-sub {\n  max-height: calc(100vh - 385px) !important;\n  overflow-y: auto !important;\n}\n\n.folder-toggle-button {\n  left: 246px;\n}\n\n.workspace-menu .ant-menu-item-selected {\n  background-color: transparent !important;\n}\n.leftbar:hover {\n  border-right: 1px solid var(--primary-color, #a064fa) !important;\n}\n.leftbar-slider:hover {\n  border-color: var(--primary-color, #a064fa) !important;\n  color: var(--primary-color, #a064fa) !important;\n}\n\n.leftbar:hover .leftbar-slider {\n  border-color: var(--primary-color, #a064fa) !important;\n  color: var(--primary-color, #a064fa) !important;\n}\n.resize-handle:hover .leftbar-slide {\n  border-color: var(--primary-color, #a064fa) !important;\n  color: var(--primary-color, #a064fa) !important;\n}\n.resize-handle:active .leftbar-slide {\n  border-color: var(--primary-color, #a064fa) !important;\n  color: var(--primary-color, #a064fa) !important;\n}\n/* Context menu styles */\n.ant-popover-inner-content .ant-btn {\n  /* width: 100%; */\n  text-align: left;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  /* padding: 8px 12px; */\n  /* margin-bottom: 4px; */\n  border-radius: 4px;\n}\n\n/* .ant-popover-inner-content .ant-btn:hover {\n  background-color: #f5f5f5;\n  color: var(--primary-color);\n} */\n\n/* Improve leftbar slider button */\n.leftbar-slider {\n  position: absolute;\n  top: 50%;\n  right: -16px;\n  transform: translateY(-50%);\n  z-index: 151;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n}\n\n/* Disable transitions during resize */\nbody.resizing-leftbar .leftbar {\n  transition: none !important;\n}\n\n/* .workspace-menu .ant-tooltip-inner {\n  background-color: #333 !important; \n  color: #fff !important;            \n  font-size: 12px;                  \n} */\n\n/* Fix for tooltip text color */\n.ant-tooltip-inner {\n  color: white !important;\n}\n\n/* Fix for menu title in collapsed mode */\n.workspace-menu-collapsed .ant-menu-item-only-child {\n  padding-left: 8px !important;\n}\n\n/* Ensure proper tooltip behavior in collapsed state */\n.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner {\n  color: white !important;\n}\n\n.leftbar-workspaceList {\n  overflow-y: scroll;\n  max-height: calc(100vh - 420px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
